import { Plugin, TextSelection } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { isEmptyDoc, isOriginAttrs, removeExcludesMarks, resetUnInheritAttr } from '../../libs';
import { DecoKey } from '../decoration';
import { BasicView } from './basic-view';
import { cardInput, cardSingleClick } from './card';
import { BSControlKey } from './const';
import { chainClickEvent, chainKeyDownEvent, createPlaceHolder, insertDefaultNodeWhenBlock, passZeroWidthChar, } from './utils';
var BasicCtrlPlugin = function (config, _editable) {
    if (_editable === void 0) { _editable = true; }
    var editable = _editable;
    return new Plugin({
        key: BSControlKey,
        state: {
            init: function () {
                return {
                    listNestedLevel: 0,
                };
            },
            apply: function (tr, set) {
                var data = tr.getMeta(BSControlKey);
                if (!data)
                    return set;
                if (data.listNestedLevel !== undefined) {
                    set.listNestedLevel = data.listNestedLevel;
                }
                if (data.editable !== undefined) {
                    editable = data.editable;
                }
                return set;
            },
        },
        props: {
            handleDOMEvents: {
                paste: function (view) {
                    var state = view.state, dispatch = view.dispatch;
                    var $from = state.selection.$from;
                    if ($from.depth === 1 &&
                        state.selection instanceof TextSelection &&
                        !$from.parent.content.size &&
                        isOriginAttrs($from.parent)) {
                        dispatch(view.state.tr.setSelection(TextSelection.create(state.doc, $from.before(), $from.after())));
                    }
                    return false;
                },
            },
            editable: function () { return editable; },
            decorations: function (state) {
                if (!config.placeholder)
                    return;
                var doc = state.doc;
                var decoState = DecoKey.getState(state);
                if (decoState === DecorationSet.empty && isEmptyDoc(state.doc)) {
                    return DecorationSet.create(doc, [Decoration.widget(1, createPlaceHolder(config.placeholder))]);
                }
            },
            handleClickOn: function (view, pos, node, nodePos, event) {
                if (!editable)
                    return false;
                return chainClickEvent({ node: node, view: view, pos: pos, nodePos: nodePos, event: event }, cardSingleClick);
            },
            handleClick: function (view, pos, event) {
                if (config.clickSpacingToInsertLine !== false) {
                    insertDefaultNodeWhenBlock(view, pos, event);
                }
                return false;
            },
            handleKeyDown: function (view, event) {
                if (!editable)
                    return false;
                return chainKeyDownEvent(view, event, passZeroWidthChar, cardInput);
            },
        },
        view: function (view) { return new BasicView(view, config); },
        appendTransaction: function (trs, oldState, newState) {
            var tr = newState.tr;
            var isModify = false;
            if (!oldState.storedMarks && newState.storedMarks && oldState.doc.nodeSize !== newState.doc.nodeSize) {
                newState.storedMarks.forEach(function (mark) {
                    // do not clear mark which has `spec.notStore`
                    if (mark.type.spec.notStore) {
                        tr.removeStoredMark(mark);
                        isModify = true;
                    }
                });
            }
            var $from = newState.selection.$from;
            if ($from.depth) {
                var isRemoved = removeExcludesMarks(tr);
                if (isRemoved && !isModify)
                    isModify = true;
                resetUnInheritAttr(oldState, newState);
            }
            return isModify ? tr : undefined;
        },
    });
};
export { BasicCtrlPlugin };
//# sourceMappingURL=plugin.js.map